<template>
  <div class="container mt-5">
    <h2 class="text-center mb-4">웹사이트 이용약관</h2>
    <div class="terms-section">
      <div class="mb-4">
        <h3>제1조 (목적)</h3>
        <p>
          본 약관은 [김프모아] (이하 "회사")가 제공하는 인터넷 관련 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
        </p>
      </div>

      <div class="mb-4">
        <h3>제2조 (정의)</h3>
        <p>
          <strong>"웹사이트"</strong>란 회사가 운영하는 온라인 사이트를 의미합니다.<br>
          <strong>"이용자"</strong>란 본 웹사이트에 접속하여 본 약관에 따라 서비스를 이용하는 모든 자를 의미합니다.
        </p>
      </div>

      <div class="mb-4">
        <h3>제3조 (약관의 게시 및 변경)</h3>
        <p>
          본 약관은 웹사이트 초기 화면 또는 연결 화면에 게시됩니다.<br>
          회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있으며, 개정 약관은 적용일 7일 전부터 공지합니다.<br>
          이용자는 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단할 수 있습니다.
        </p>
      </div>

      <div class="mb-4">
        <h3>제4조 (서비스의 제공 및 변경)</h3>
        <p>
          회사는 다음과 같은 서비스를 제공합니다.<br>
          - 웹사이트를 통한 정보 제공<br>
          - 기타 회사가 추가 개발하는 서비스<br><br>
          회사는 필요에 따라 서비스 내용을 변경할 수 있으며, 중요한 변경이 있을 경우 사전에 공지합니다.
        </p>
      </div>

      <div class="mb-4">
        <h3>제5조 (서비스 이용 제한 및 중단)</h3>
        <p>
          회사는 다음과 같은 사유가 발생한 경우 서비스 제공을 제한하거나 중단할 수 있습니다.<br>
          - 설비 점검, 유지보수 등 기술적인 사유가 있는 경우<br>
          - 천재지변, 전쟁, 국가비상사태 등 불가항력적인 사유가 있는 경우<br>
          - 이용자가 본 약관을 위반하여 서비스 운영에 지장을 초래하는 경우<br><br>
          회사는 위 사유로 인해 서비스가 중단될 경우 사전 또는 사후에 이용자에게 이를 공지합니다.
        </p>
      </div>

      <div class="mb-4">
        <h3>제6조 (개인정보 보호)</h3>
        <p>
          본 웹사이트는 회원가입을 받지 않으며, 별도의 개인정보를 수집하지 않습니다.<br>
          단, 웹사이트 운영을 위해 자동으로 수집되는 접속 정보(예: IP 주소, 쿠키 등)에 대한 보호 조치는 회사의 [개인정보 처리방침]에 따릅니다.
        </p>
      </div>

      <div class="mb-4">
        <h3>제7조 (이용자의 의무)</h3>
        <p>
          이용자는 다음 행위를 해서는 안 됩니다.<br>
          - 웹사이트 내 제공된 정보를 무단 변경, 삭제 또는 복제하는 행위<br>
          - 웹사이트의 정상적인 운영을 방해하는 행위<br>
          - 회사 또는 제3자의 권리를 침해하거나 명예를 훼손하는 행위<br>
          - 기타 관련 법령에 위반되는 행위
        </p>
      </div>

      <div class="mb-4">
        <h3>제8조 (책임의 제한)</h3>
        <p>
          회사는 천재지변, 국가비상사태, 기술적 장애 등 불가항력적인 사유로 인해 서비스를 제공할 수 없는 경우 책임을 지지 않습니다.<br>
          회사는 이용자가 본 서비스를 이용하여 기대하는 이익을 얻지 못하거나 발생한 손해에 대해 책임을 지지 않습니다.<br>
          회사는 웹사이트 내 제공된 정보의 정확성, 신뢰성에 대해 보장하지 않으며, 이용자가 이를 신뢰하여 발생한 손해에 대해 책임을 지지 않습니다.
        </p>
      </div>
      <!--
      <div class="mb-4">
        <h3>제9조 (준거법 및 재판 관할)</h3>
        <p>
          본 약관과 관련된 분쟁은 대한민국 법률을 따르며, 관할 법원은 회사의 본사 소재지를 관할하는 법원으로 합니다.
        </p>
      </div>
      -->
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsOfService",
};
</script>

<style scoped>
.terms-section {
  text-align: left;
}
  
.terms-section h3 {
  font-weight: bold;
}

.terms-section p {
  font-size: 1.1rem;
  color: #333;
}
</style>
